import { CalendarDays, ChartColumn, LucideIcon, SlidersHorizontal } from 'lucide-react';
import { TitleEntry } from '../../../navigation/titleEntry';
import { OOS_CAMERA_DAYS_PATH, OOS_DASHBOARD_PATH, OOS_STRATEGIES_PATH } from '../../paths';

/**
 * The one list of OOS destinations. The sidebar renders it, the mobile topbar
 * takes its label from it, and the browser tab is named from it.
 */
export interface OosNavItem {
  label: string;
  icon: LucideIcon;
  path: string;
}

export const OOS_NAV_ITEMS: OosNavItem[] = [
  { label: 'Dashboard', icon: ChartColumn, path: OOS_DASHBOARD_PATH },
  { label: 'Camera-days', icon: CalendarDays, path: OOS_CAMERA_DAYS_PATH },
  { label: 'Strategies', icon: SlidersHorizontal, path: OOS_STRATEGIES_PATH },
];

export const OOS_APP_TITLE = 'OOS';

/** The nav item that owns a path; a camera-day belongs to Camera-days. */
export const oosNavItemFor = (pathname: string): OosNavItem | undefined =>
  OOS_NAV_ITEMS.find((item) => pathname === item.path || pathname.startsWith(`${item.path}/`));

/** Top bar title on mobile: the label of the page that owns the path, else 'OOS'. */
export const getOosPageLabel = (pathname: string): string =>
  oosNavItemFor(pathname)?.label ?? OOS_APP_TITLE;

/** Browser tab names for OOS. */
export const OOS_TITLE_ENTRIES: TitleEntry[] = [
  ...OOS_NAV_ITEMS.map((item) => ({ path: item.path, label: item.label })),
  {
    path: `${OOS_CAMERA_DAYS_PATH}/:cameraDayId/timelines`,
    label: 'Timelines',
    params: [{ name: 'cameraDayId' }],
  },
  {
    path: `${OOS_CAMERA_DAYS_PATH}/:cameraDayId/images`,
    label: 'Images',
    params: [{ name: 'cameraDayId' }],
  },
];
